import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import DownloadsContent from '../components/DownloadsContent';
const Downloads = () => {
	return (
		<>
			<Navbar />
			<DownloadsContent />
			<Footer />
		</>
	);
};

export default Downloads;
